export default "__VITE_ASSET__DYltZU$A__"